import { IStore } from 'store/configureStore';

export const selectIsOfferEditing = (state: IStore) => state.modules.offerLetter.offerEdit.isOfferEditing;
